<template>
  <b-dropdown :text="text" class="custom-dropdown">
    <b-dropdown-item
      v-for="(option, index) in filteredOptions"
      :key="'option_' + index + option.value"
      dropdown
      @click="selectOption(option)"
    >
      <b-icon
        v-if="getCircleStyle(option.value).color"
        icon="circle-fill"
        scale="1"
        :style="getCircleStyle(option.value)"
      />
      {{ option.text }}
    </b-dropdown-item>
  </b-dropdown>
</template>

<script lang="ts">
import type { SelectOptions, SelectValue } from '@/types/Components/SelectOptions'
import type { StatusType } from '@/types/Models/Assignment'
import { BDropdown, BDropdownItem } from 'bootstrap-vue-next'
import { defineComponent, ref, computed, type ComputedRef, type Ref } from 'vue'
import { StatusColor } from '@/services/Status/StatusColor'
import BIcon from '@/views/Components/Elements/Icons/BIcon.vue'

export default defineComponent({
  name: 'FilterDropdown',
  components: { BDropdown, BDropdownItem, BIcon },
  props: {
    options: {
      type: Array as () => SelectOptions[],
      required: true,
    },
  },
  emits: ['select:change'],
  setup(props, { emit }) {
    const value: Ref<SelectValue> = ref(props.options[0]?.value || null)
    const text: Ref<string | undefined> = ref(props.options[0]?.text || 'Select option')

    const filteredOptions: ComputedRef<SelectOptions[]> = computed(() => props.options)

    const getCircleStyle = (status: StatusType) => ({ color: StatusColor[status] || '' })

    const selectOption = (option: SelectOptions) => {
      emit('select:change', option.value)
      value.value = option.value
      text.value = option.text
    }

    return {
      text,
      value,
      filteredOptions,
      getCircleStyle,
      selectOption,
    }
  },
})
</script>

<style lang="scss" scoped>
.custom-dropdown {
  &.show {
    :deep(.dropdown-toggle) {
      background-color: #ffffff;
    }
  }

  &.border-0 {
    :deep(.dropdown-toggle) {
      border: none !important;
    }
  }

  :deep(.dropdown-menu) {
    transform: translate3d(0, 45px, 0) !important;
    z-index: 3;
    max-height: 400px;
    overflow-y: auto;
  }

  :deep(.dropdown-toggle) {
    width: 172px;
    height: 40px;
    font-size: 14px;
    color: #757575;
    border-color: #c8c8c8;
    padding-left: 15px;
    text-align: left;
    line-height: 0;
    text-overflow: ellipsis;
    overflow: hidden;
    background: #ffffff url(@/assets/img/icon-select.svg) right 14px top 14px / 12px 12px no-repeat !important;
    &:hover,
    &:focus,
    &:active {
      background-color: unset;
      border-color: #c8c8c8;
      color: #757575;
    }
    &::after {
      display: none;
    }
  }
}
</style>
